import { render, staticRenderFns } from "./ImportProviders.vue?vue&type=template&id=a2b592c6&"
import script from "./ImportProviders.vue?vue&type=script&lang=js&"
export * from "./ImportProviders.vue?vue&type=script&lang=js&"
import style0 from "./ImportProviders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports